import { render, staticRenderFns } from "./HomepageWelcome.vue?vue&type=template&id=a3860f62&scoped=true&"
import script from "./HomepageWelcome.vue?vue&type=script&lang=js&"
export * from "./HomepageWelcome.vue?vue&type=script&lang=js&"
import style0 from "./HomepageWelcome.vue?vue&type=style&index=0&id=a3860f62&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3860f62",
  null
  
)

/* custom blocks */
import block0 from "./HomepageWelcome.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImage: require('/opt/build/repo/components/AppImage.vue').default,AppButton: require('/opt/build/repo/components/AppButton.vue').default})
